<!-- @format -->

<template>
	<div>
		<el-button type="primary" @click="sendNotify">模拟后台发送消息</el-button>
	</div>
</template>

<script>
	import { useGlobalStoreWithOut, getEnvUrlByUrl } from '@power/runtime-vue3';
	import io from 'socket.io-client';

	export default {
		data() {
			return {
				userId: null,
				socket: null,
				systemSocketShow: '',
			};
		},
		created() {
			// 获取系统配置的socket是否开启
			const socketArr = useGlobalStoreWithOut().$state.frontEndConfig;
			this.systemSocketShow = this.loginDataFilter(socketArr, 'socket', 'enableSocket').itemValue;
			if (this.systemSocketShow === 'Y') {
				this.connect();
			}
		},
		methods: {
			sendNotify() {
				// let sendParams = {
				// 	fromUserId: '1',
				// 	paramsWay: 'html',
				// 	toUserId: this.userId,
				// 	noticeType: 'inner',
				// 	msgType: 'inner',
				// 	params: '{"instSubject":"测试","nodeName":"测试节点"}',
				// 	tplId: '139728732518351001',
				// };
				// sendSocketMessage(sendParams).then((res) => {});

				const url = 'http://192.168.140.42:7200/sendAllMessage?userId=2&userName=qsp&toUserId=1&message=123455';
				window.open(url, '_blank');
			},
			connect() {
				// 获取userID
				this.userId = useGlobalStoreWithOut().$state.userInfo.user.id;
				// this.socket = io('/' + '?userId=' + this.userId);
				this.socket = io(getEnvUrlByUrl('/'), {
					query: `userId=${this.userId}`,
					transports: ['websocket'],
				});
				// // 进行socket连接
				this.socket.on('connect', () => {
					//console.log('socket连接成功');
				});
				// // 接收消息
				this.socket.on('soft.send.event', (resData) => {
					try {
						// socket数据推送回来 做相应的处理
						ElNotification({
							title: '消息提示',
							dangerouslyUseHTMLString: true,
							message: resData.message,
							position: 'bottom-right',
							duration: 0,
						});
					} catch (err) {
						// console.log('err', err);
					}
				});
				// // 断开socket连接
				this.socket.on('disconnect', () => {
					//console.log('disconnect');
				});
				// // socket连接错误
				this.socket.on('connect_error', () => {
					try {
						this.socket.close();
					} catch (err) {
						console.log('err', err);
					}
				});
			},
			loginDataFilter: (options, valueKey, codeType) => {
				if (options.length > 0) {
					let optMap = {};
					options.forEach((x) => {
						if (x.code === valueKey) {
							x.sysConfigVos.forEach((item) => {
								if (item.itemCode === codeType) {
									optMap = item;
								}
							});
						}
					});
					return optMap;
				}
			},
		},
	};
</script>
